import React, {useEffect, useState} from "react";
import {
  Box, 
  Typography, 
  Grid,
  MenuItem,
} from "@mui/material";
import RegisterStyles from "../../assets/css/register.styles";
import { useSelector } from 'react-redux';  
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CustomLabeledTextField from "../../components/customTextField/customLabeledTextField"; 
import { emailRegex, kuwaitPhoneNumberDigits, kuwaitPhoneNumberRegex, Lowercase, Numbercase, passwordCharactersMinimum, SpecialChar, Uppercase } from "../../constants/registerConstants";
import CustomLabeledSelect from "../../components/customSelect/customLabeledSelect";  
import GridStyles from "../../assets/css/grid.styles";
import CustomButton from "../../components/customButton/customButton"; 
import CustomLabeledDatePicker from "../../components/customDatePicker/customLabeledDatePicker";
import { isDateEarlierThanToday } from "../../helpers/useDateHelpers";
import CustomLabeledFileInput from "../../components/customFileInput/customLabeledFileInput"; 
import { AddCircle, Cancel  } from "@mui/icons-material";
import { validImageExtensions } from "../../constants/extensions"; 
import CustomIcon from "../../components/customIcon/customIcon";
import { AICClient, Countries, FileTypes, LookupEnum } from "../../constants/enums";
import { RootState } from "../../store/store";
import { getCities } from "../../reducers/cityReducer";
import { getAreas } from "../../reducers/areaReducer";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { RegisterTouched } from "./registerTouched";
import { InvestorModel } from "../../models/models/investorModel";
import { ValidatableComponent } from "./validatableComponent";
import { validateCivilId } from "../../helpers/useValidateCivilIdHelpers";
import { getAICClient, getDesignations, getGender, getPreferenceCommunication } from "../../reducers/lookupReducer";
import { getSuburbs } from "../../reducers/suburbReducer";
import { InvestorEmployerModel } from "../../models/models/investorEmployerModel";


const PersonalInformation: ValidatableComponent = ({
  formData,
  setFormData,
  touched,
  setTouched,
  confirmPassword,
  setConfirmPassword,
  countries,
  handleSaveAndContinue,
  validateEmployers,
  t,
  isRTL
}) => {
  const dispatch = useAppDispatch();
  const [isVisible, setIsVisible] = useState(false); 
  const cities = useSelector((state: RootState) => state.city.cities);
  const areas = useSelector((state: RootState) => state.area.areas); 
  const preferenceCommunicationList = useSelector((state: RootState) => state.lookup.preferenceCommunication);
  const genderList = useSelector((state: RootState) => state.lookup.gender);
  const aicClients = useSelector((state: RootState) => state.lookup.aicClient);
  const designations = useSelector((state: RootState) => state.lookup.designations);
  const suburbs = useSelector((state: RootState) => state.suburb.suburbs);

   useEffect(() => { 
      dispatch(getPreferenceCommunication({lookupId: LookupEnum.PreferenceCommunication}));
      dispatch(getGender({lookupId: LookupEnum.Gender}));
      dispatch(getAICClient({lookupId: LookupEnum.AICClient}));
      dispatch(getDesignations({lookupId: LookupEnum.Designations}));
   },[]);
   
   useEffect(() => { 
      if (formData.countryId && formData.countryId === Countries.KuwaitId) { 
          setFormData((prevData) => ({
            ...prevData,
              city: '',
              area: '',
              suburb: '',
          }));
        }else{
          setFormData((prevData) => ({
            ...prevData,
              cityId: null,
              areaId: null,
              suburbId: null,
          }));
        }
    }, [formData.countryId]);  

   useEffect(() => { 
      if (formData.countryId && formData.countryId === Countries.KuwaitId) { 
          dispatch(getCities({ id: formData.countryId }));
          dispatch(getAreas({ id: formData.countryId }));
          dispatch(getSuburbs({ id: formData.countryId }));
        }
    }, [formData.countryId]);  

const handlePhoneNumberBlur = () => {   
    if(formData.mobileCountryId === Countries.KuwaitId && formData.mobileNumber !== null && (!kuwaitPhoneNumberRegex.test(formData.mobileNumber.toString()) || formData.mobileNumber.toString().length != kuwaitPhoneNumberDigits) || formData.mobileNumber === null){
        setTouched((prevData) => ({
            ...prevData,
            mobileNumber: true,
        }))
    }
    else{
      setTouched((prevData) => ({
        ...prevData,
        mobileNumber: false,
    }))
    }
};

    useEffect(() => {
        if (formData.mobileCountryId && formData.mobileNumber !== null) {
          handlePhoneNumberBlur();
        }
      }, [formData.mobileCountryId]); 


const handlePasswordBlur = () => { 
    if (formData.password.length < passwordCharactersMinimum || !Uppercase.test(formData.password) || !Lowercase.test(formData.password) || !Numbercase.test(formData.password) || !SpecialChar.test(formData.password) ||
      formData.firstName.toLowerCase().trim() !== "" && formData.password.toLowerCase().includes(formData.firstName?.toLowerCase()) ||
    formData.lastName.toLowerCase().trim() !== "" && formData.password.toLowerCase().includes(formData.lastName?.toLowerCase())
  ) {
        setTouched((prevData) => ({
            ...prevData,
            password: true,
        })) 
    } 
  };

const handleConfirmPasswordBlur = () => { 
    if (confirmPassword.trim() === "" || confirmPassword !== formData.password) {
        setTouched((prevData) => ({
            ...prevData,
            confirmPassword: true,
        })) 
    } 
  }; 
  const handleEmailBlur = () => {
    if (!emailRegex.test(formData.email)) {
      setTouched((prevData) => ({
        ...prevData,
        email: true,
      }));
    }
  }; 
  
  const handleCivilIdBlur = () => {     
    if (formData.nationalities.includes(Countries.KuwaitId) && (formData.civilIdNumber === null || (formData.civilIdNumber !== null && !validateCivilId(formData.civilIdNumber)))) {
        setTouched((prevData) => ({
            ...prevData,
            civilIdNumber: true,
        })) 
    } 
}; 
 
    const getTypeId = (name: string): number => {
    switch (name) {
        case "civilId":
            return FileTypes.CivilIdDocument; 
        case "passport":
            return FileTypes.PassportDocument;  
        default:
            return 0;
    }
    };

  const handleCivilDocumentChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => { 
    const { files } = event.target;
    if (files && files.length > 0) {
      const file = files[0];
      const reader = new FileReader();

      reader.onload = () => {
        const binaryData = reader.result as string;
        const base64String = window.btoa(binaryData); 
        setFormData((prevFormData) => ({
            ...prevFormData,
            civilIdDocument: {
                fileName: file.name.substr(0, file.name.lastIndexOf(".")),
                extension: file.name.split(".").pop()?.toLowerCase() ?? "",
                contentType: file.type,
                data: base64String,
                date: "",
                typeId: getTypeId('civilId'),
              },
          })) 
      };

      reader.readAsBinaryString(file);
    } else {
        setFormData((prevFormData) => ({
            ...prevFormData,
            civilIdDocument: {
                typeId: 0,
                type: "",
                fileName: "",
                fileUrl: "",
                date: "",
                extension: "",
                contentType: "",
                data: "",
              },
          })) 
    }
  };

  const handlePassportDocumentChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => { 
    const { files } = event.target;
    if (files && files.length > 0) {
      const file = files[0]; 
      const isFileExtensionValid = file.name.split(".").pop()?.toLowerCase()
      ? validImageExtensions.includes(file.name.split(".").pop()?.toLowerCase() || "")
      : false;
      setTouched((prevData) => ({
        ...prevData,
        passportDocumentType: false,
        passportDocumentSize: false,
    })) 
      const maxSizeInBytes = 1048576;
      const isFileSizeValid = file.size <= maxSizeInBytes;
  
      if (!isFileExtensionValid || !isFileSizeValid) {
        setTouched((prevData) => ({
            ...prevData,
            passportDocumentType: !isFileExtensionValid,
            passportDocumentSize: !isFileSizeValid,
        })) 
      } 

      const reader = new FileReader();

      reader.onload = () => {
        const binaryData = reader.result as string;
        const base64String = window.btoa(binaryData); 
        setFormData((prevFormData) => ({
            ...prevFormData,
            passportDocument: {
                fileName: file.name.substr(0, file.name.lastIndexOf(".")),
                extension: file.name.split(".").pop()?.toLowerCase() ?? "",
                contentType: file.type,
                data: base64String,
                date: "",
                typeId: getTypeId("passport"),
              },
          })) 
      };

      reader.readAsBinaryString(file);
    } else {
        setFormData((prevFormData) => ({
            ...prevFormData,
            passportDocument: {
                typeId: 0,
                type: "",
                fileName: "",
                fileUrl: "",
                date: "",
                extension: "",
                contentType: "",
                data: "",
              },
          })) 
    }
  };

  const addEmployer = () => {
    setFormData((prevData) => ({
      ...prevData,
      employers: [
        ...prevData.employers,
        {
          id: 0,
          name: "",
          address: "",
          phoneNumber: null,
          phoneCountryId: null,
          email: "",
          designationId: null,
        },
      ],
    }));
  
    setTouched((prevTouched) => ({
      ...prevTouched,
      employers: [
        ...prevTouched.employers || [],
        {
          name: false,
          address: false,
          phoneNumber: false,
          phoneCountryId: false,
          email: false,
          designationId: false,
        },
      ],
    }));
  };
   
 
const removeEmployer = (index: number) => {
  setFormData((prevData) => ({
    ...prevData,
    employers: prevData.employers.filter((_, i) => i !== index),
  }));
};
 
const handleInputChange = (
  index: number,
  field: keyof InvestorEmployerModel,
  value: string
) => {
  setFormData((prevData) => {
    const updatedEmployers = prevData.employers.map((employer, i) =>
      i === index ? { ...employer, [field]: value } : employer
    ); 
    validateEmployers();
    return {
      ...prevData,
      employers: updatedEmployers, 
    };
  });
};


const handleCountryCodeChange = (index: number, countryId: number) => {
  setFormData((prevData) => ({
    ...prevData,
    employers: prevData.employers.map((employer, i) =>
      i === index ? { ...employer, phoneCountryId: countryId } : employer
    ),
  }));
};

const handleDesignationChange = (index: number, designationId: number) => {
  setFormData((prevData) => {
    const updatedEmployers = prevData.employers.map((employer, i) =>
      i === index ? { ...employer, designationId: designationId } : employer
    ); 
    validateEmployers();
    return {
      ...prevData,
      employers: updatedEmployers, 
    };
  });
};



  return (
    <Box
    display="flex"
    flexDirection="column"
    gap={2}
    mb={2}
    pl={5}
    sx={{
      textAlign: isRTL ? "right" : "left",
      direction: isRTL ? "rtl" : "ltr", 
      marginRight: '50px', 
    }}
  >
      <Box sx={{...RegisterStyles.boxStyle, ...RegisterStyles.mainSection }}>
        <Grid container item xs={12} sm={12} md={12} spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <CustomLabeledTextField
              label={`${t('email')}`}
              name="email"
              type="text"
              isRTL={isRTL}
              value={formData.email}
              onBlur={handleEmailBlur}
              onChange={(e) =>
                setFormData((prevData) => ({ ...prevData, email: e.target.value }))
              }
              required={true}
              disabled = {formData.id !== 0}
              error={touched.email && (formData.email.trim() === "" || !emailRegex.test(formData.email))}
              helperText={
                touched.email && (formData.email.trim() === "" || !emailRegex.test(formData.email))
                  ? `${t('emailValidation')}` 
                  : ""
              } 
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CustomLabeledTextField 
              label={`${t('mobileNumber')}`}
              name="mobileNumber"
              type="text"
              isRTL={isRTL}
              numericInput={true}
              allowDecimal={true}
              allowNegative={false}
              value={formData.mobileNumber} 
              onChange={(e) =>{
                const { name, value } = e.target;
                if (!isNaN(Number(value))) {
                    setFormData((prevData) => ({
                    ...prevData,
                    mobileNumber: parseFloat(value),
                  }));
                } else{
                  setTouched((prevData) => ({
                    ...prevData,
                    mobileNumber: true,
                  }))
                }
              }}
              required={true}
              isPhoneNumber={true}
              disabled = {formData.id !== 0}
              countryCode={formData.mobileCountryId || 0}
              countryCodes={countries || []} 
              onCountryCodeChange={(countryId) =>
                setFormData({ ...formData, mobileCountryId: countryId })
              }
              onBlur={handlePhoneNumberBlur}
              error={touched.mobileNumber && (formData.mobileNumber === null || (formData.mobileCountryId === Countries.KuwaitId && formData.mobileNumber !== null && (!kuwaitPhoneNumberRegex.test(formData.mobileNumber.toString()) || formData.mobileNumber.toString().length != kuwaitPhoneNumberDigits) || formData.mobileNumber === null))}
              helperText={(
                touched.mobileNumber && formData.mobileNumber === null && formData.mobileCountryId !== Countries.KuwaitId
                 ? `${t('mandatoryField')}`
                : touched.mobileNumber && (formData.mobileNumber === null || (formData.mobileCountryId === Countries.KuwaitId && formData.mobileNumber !== null && (!kuwaitPhoneNumberRegex.test(formData.mobileNumber.toString()) || formData.mobileNumber.toString().length != kuwaitPhoneNumberDigits) || formData.mobileNumber === null))) ? `${t('phoneNumberValidation')}` : ''} 
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CustomLabeledSelect 
              label={`${t('preferenceCommunication')}`}
              name="receiveCommunicationId"
              type="text"
              isRTL={isRTL}
              disabled = {formData.id !== 0}
              SelectProps={{
                children: Array.isArray(preferenceCommunicationList.data) ? (
                  preferenceCommunicationList.data.map((item: any) => (
                    <MenuItem key={item.id} value={item.id}>
                    {isRTL ? item.valueAr : item.valueEn}
                    </MenuItem>
                ))
                ) : preferenceCommunicationList.data instanceof Object ? (
                <MenuItem
                    key={(preferenceCommunicationList.data as any).id}
                    value={(preferenceCommunicationList.data as any).id}
                >
                    {(preferenceCommunicationList.data as any).valueEn}
                </MenuItem>
                ) : null,

                IconComponent: () => null,
                renderValue: (value: any) => {
                if (Array.isArray(preferenceCommunicationList.data)) {
                    const selected = preferenceCommunicationList.data.filter(
                    (item: any) => value.includes(item.id)
                    );
                    return selected
                    .map((item) => item.valueEn)
                    .join(", ");
                } else if (preferenceCommunicationList.data instanceof Object) {
                    return (preferenceCommunicationList.data as any).valueEn || "";
                }
                return "";
                },
              }}
              value={formData.receiveCommunicationId || ""}
              onChange={(e) =>
                setFormData((prevData) => ({
                  ...prevData,
                  receiveCommunicationId: e.target.value as number,
                }))
              }
              multiple={false}
              required={true}
              error={
                touched.receiveCommunicationId &&
                formData.receiveCommunicationId === null
              }
              helperText={
                touched.receiveCommunicationId &&
                formData.receiveCommunicationId === null
                  ? `${t('mandatoryField')}`
                  : ""
              }
            />
          </Grid>
        </Grid>
        {formData.id === 0 && (
          <>
            <Grid container item xs={12} sm={12}  mt={1} md={12} spacing={2}>
            <Grid item xs={12} sm={4}>
              <CustomLabeledTextField 
                label={`${t('password')}`}
                name="password" 
                isRTL={isRTL}
                type={isVisible ? "text" :"password"}
                icon={isVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                onClickOnIcon={() => setIsVisible(!isVisible)}  
                value={formData.password}
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    password: e.target.value,
                  }))
                }
                required={true}
                onBlur={handlePasswordBlur}
                error={touched.password && (
                  formData.password.trim() === "" || formData.password.length < passwordCharactersMinimum || !Uppercase.test(formData.password) || !Lowercase.test(formData.password) || !Numbercase.test(formData.password) || !SpecialChar.test(formData.password) 
                  || formData.firstName.toLowerCase().trim() !== "" && formData.password.toLowerCase().includes(formData.firstName?.toLowerCase()) ||
                  formData.lastName.toLowerCase().trim() !== "" && formData.password.toLowerCase().includes(formData.lastName?.toLowerCase())
                )}
                helperText={
                    (touched.password && (formData.password.trim() === "" || formData.password.length < passwordCharactersMinimum))
                    ? `${t('passwordMandatoryValidation')}`
                    : (touched.password && !Uppercase.test(formData.password))  ? `${t('upperCaseValidation')}`
                    : (touched.password && !Lowercase.test(formData.password))  ? `${t('lowerCaseValidation')}` 
                    : (touched.password && !Numbercase.test(formData.password))  ? `${t('numericValidation')}`
                    : (touched.password && !SpecialChar.test(formData.password))  ? `${t('specialCharsValidation')}`
                    : (touched.password && (formData.firstName.toLowerCase().trim() !== "" && formData.password.toLowerCase().includes(formData.firstName?.toLowerCase()) ||
                    formData.lastName.toLowerCase().trim() !== "" && formData.password.toLowerCase().includes(formData.lastName?.toLowerCase())))  ? `${t('passwordInfoValidation')}`                  
                    : ""
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CustomLabeledTextField  
                label={`${t('confirmPassword')}`}
                name="confirmPassword" 
                type="password"
                isRTL={isRTL}
                value={confirmPassword}
                onChange={(e) =>
                  setConfirmPassword(e.target.value) 
                }
                required={true} 
                onBlur={handleConfirmPasswordBlur}
                error={touched.confirmPassword && (confirmPassword.trim() === "" || confirmPassword !== formData.password)} 
                helperText={
                  touched.confirmPassword && confirmPassword.trim() === "" ? `${t('confirmPasswordValidation')}`: 
                  touched.confirmPassword && confirmPassword !== formData.password ? `${t('doesNotMatchValidation')}`  : ""}
              />
            </Grid>
            </Grid> 
            <Grid container spacing={2} mt={1} sx={{ flexDirection: { xs: "column", sm: "row" } }}>
                <Grid item xs={12} sm={6} md={3}> 
                    <div style={GridStyles.addButtonContainer}>
                        <CustomButton
                        type="button"
                        style={GridStyles.addButton}
                        onClick={handleSaveAndContinue}
                        >
                        {t('saveAndContinue')}
                        </CustomButton>
                    </div>
                </Grid>  
            </Grid>
          </>
        )}  
      </Box>
      <Box sx={RegisterStyles.boxStyle}>
        <Grid container item xs={12} sm={12} md={12} spacing={2}>
            <Grid item xs={12} sm={4}> 
              <CustomLabeledSelect
                  label={`${t('aicClient')}`} 
                  name="aicClientId"
                  type="text"
                  isRTL={isRTL}
                  SelectProps={{
                      children: Array.isArray(aicClients.data) ? (
                        aicClients.data.map((item: any) => (
                          <MenuItem key={item.id} value={item.id}>
                            {isRTL ? item.valueAr : item.valueEn}
                          </MenuItem>
                        ))
                      ) : aicClients.data instanceof Object ? (
                        <MenuItem
                          key={(aicClients.data as any).id}
                          value={(aicClients.data as any).id}
                        >
                          {(aicClients.data as any).valueEn}
                        </MenuItem>
                      ) : null,

                      IconComponent: () => null,
                      renderValue: (value: any) => {
                        if (Array.isArray(aicClients.data)) {
                          const selected = aicClients.data.filter(
                            (item: any) => value.includes(item.id)
                          );
                          return selected
                            .map((item) => item.valueEn)
                            .join(", ");
                        } else if (aicClients.data instanceof Object) {
                          return (aicClients.data as any).valueEn || "";
                        }
                        return "";
                      },
                    }}
                  value={formData.aicClientId || ""}
                  onChange={(e) =>
                      setFormData((prevData) => ({
                      ...prevData,
                      aicClientId: e.target.value as number,
                      }))
                  }
                  multiple={false}
                  required={true} 
                  error={touched.aicClientId && formData.aicClientId=== null}
                  helperText={
                      touched.aicClientId && formData.aicClientId === null
                      ? `${t('mandatoryField')}` 
                      : ""
                      }
              /> 
           </Grid> 
          <Grid item xs={12} sm={4}>
            <CustomLabeledTextField 
              label={`${t('ifIsAicClient')}`}
              name="aicPortfolioNumber"
              type="text"
              isRTL={isRTL}
              value={formData.aicPortfolioNumber} 
              onChange={(e) =>
                setFormData((prevData) => ({ ...prevData, aicPortfolioNumber: e.target.value }))
              }
              required={formData.aicClientId === AICClient.Yes}
              disabled={formData.aicClientId  !== AICClient.Yes}
              error={touched.aicPortfolioNumber && formData.aicPortfolioNumber.trim() === "" && formData.aicClientId === AICClient.Yes}
              helperText={
                touched.aicPortfolioNumber && formData.aicPortfolioNumber.trim() === "" && formData.aicClientId === AICClient.Yes
                  ? `${t('mandatoryField')}` 
                  : ""
              } 
            />
          </Grid> 
        </Grid>  
        <Grid container item xs={12} sm={12}  mt={1} md={12} spacing={2}>
            <Grid item xs={12} sm={12}> 
                <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}> 
                    {t('officialFullName')}
                </Typography> 
                <Grid container item xs={12} sm={12}  mt={1} md={12} spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={`${t('firstName')}`}
                            name="firstName"
                            type="text"
                            isRTL={isRTL}
                            value={formData.firstName} 
                            onChange={(e) =>
                                setFormData((prevData) => ({ ...prevData, firstName: e.target.value }))
                            }
                            required={true}
                            error={touched.firstName && formData.firstName.trim() === ""}
                            helperText={
                                touched.firstName && formData.firstName.trim() === ""
                                ? `${t('mandatoryField')}` 
                                : ""
                                } 
                        />
                    </Grid> 
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={`${t('middleName')}`}
                            name="middleName"
                            type="text"
                            isRTL={isRTL}
                            value={formData.middleName} 
                            onChange={(e) =>
                                setFormData((prevData) => ({ ...prevData, middleName: e.target.value }))
                            }
                            required={true} 
                            error={touched.middleName && formData.middleName.trim() === ""}
                            helperText={
                                touched.middleName && formData.middleName.trim() === ""
                                ? `${t('mandatoryField')}` 
                                : ""
                                } 
                        />
                    </Grid> 
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={`${t('lastName')}`}
                            name="lastName"
                            type="text"
                            isRTL={isRTL}
                            value={formData.lastName} 
                            onChange={(e) =>
                                setFormData((prevData) => ({ ...prevData, lastName: e.target.value }))
                            }
                            required={true} 
                            error={touched.lastName && formData.lastName.trim() === ""}
                            helperText={
                                touched.lastName && formData.lastName.trim() === ""
                                ? `${t('mandatoryField')}` 
                                : ""
                                } 
                        />
                    </Grid> 
                </Grid>
            </Grid>  
        </Grid>  
        <Grid container item xs={12} sm={12}  mt={1} md={12} spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
                <CustomLabeledDatePicker
                    label={`${t('birthDate')}`}
                    invalidDateMessage={`${t('invalidDateFormat')}`}  
                    value={formData.birthDate} 
                    required={true} 
                    isRTL={isRTL}
                    onChange={(date: string) => {
                       if (isDateEarlierThanToday(date)) { 
                          setFormData({ ...formData, birthDate: date }) 
                       }else{
                        setFormData({ ...formData, birthDate: "" }) 
                        setTouched((prevData) => ({
                          ...prevData,
                          birthDate: true,
                          })); 
                       }
                    }} 
                    error={touched.birthDate && formData.birthDate.trim() === ""}
                    helperText={
                        touched.birthDate && formData.birthDate.trim() === ""
                        ? `${t('mandatoryField')}` 
                        : touched.birthDate 
                        ? `${t('earlierTodayValidation')}` 
                        : ""
                        } 
                  />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <CustomLabeledTextField 
                    label={`${t('birthPlace')}`}
                    name="birthPlace"
                    type="text"
                    isRTL={isRTL}
                    value={formData.birthPlace} 
                    onChange={(e) =>
                        setFormData((prevData) => ({ ...prevData, birthPlace: e.target.value }))
                    }
                    required={true} 
                    error={touched.birthPlace && formData.birthPlace.trim() === ""}
                    helperText={
                        touched.birthPlace && formData.birthPlace.trim() === ""
                        ? `${t('mandatoryField')}` 
                        : ""
                        } 
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>  
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <CustomLabeledSelect
                        label={`${t('gender')}`} 
                        name="genderId"
                        type="text"
                        isRTL={isRTL}
                        SelectProps={{
                          children: Array.isArray(genderList.data) ? (
                            genderList.data.map((item: any) => (
                              <MenuItem key={item.id} value={item.id}>
                              {isRTL ? item.valueAr : item.valueEn}
                              </MenuItem>
                          ))
                          ) : genderList.data instanceof Object ? (
                          <MenuItem
                              key={(genderList.data as any).id}
                              value={(genderList.data as any).id}
                          >
                              {(genderList.data as any).valueEn}
                          </MenuItem>
                          ) : null,
          
                          IconComponent: () => null,
                          renderValue: (value: any) => {
                          if (Array.isArray(genderList.data)) {
                              const selected = genderList.data.filter(
                              (item: any) => value.includes(item.id)
                              );
                              return selected
                              .map((item) => item.valueEn)
                              .join(", ");
                          } else if (genderList.data instanceof Object) {
                              return (genderList.data as any).valueEn || "";
                          }
                          return "";
                          },
                        }}
                        value={formData.genderId || ""}
                        onChange={(e) =>
                            setFormData((prevData) => ({
                            ...prevData,
                            genderId: e.target.value as number,
                            }))
                        }
                        multiple={false}
                        required={true} 
                        error={touched.genderId && formData.genderId === null}
                        helperText={
                            touched.genderId && formData.genderId === null
                            ? `${t('mandatoryField')}` 
                            : ""
                            } 
                      />
                    </Grid>
                </Grid>
            </Grid>  
        </Grid>  
        <Grid container item xs={12} sm={12}  mt={1} md={12} spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
                <CustomLabeledSelect 
                label={`${t('nationalities')}`} 
                name="nationalities"
                type="text"
                isRTL={isRTL}
                SelectProps={{
                    children: countries.map((item: any) => (
                    <MenuItem key={item.id} value={item.id}>
                        {item.nationalityEn}
                    </MenuItem>
                    )),
                    IconComponent: () => null,
                    renderValue: (value: any) => {
                    const selected = countries.filter(
                        (item: any) => value.includes(item.id)
                    );
                    return selected.map((item) => item.nationalityEn).join(", ");
                    },
                }}
                value={formData.nationalities || []}
                onChange={(e) =>
                    setFormData((prevData) => ({
                    ...prevData,
                    nationalities: e.target.value as number[],
                    }))
                }
                multiple={true}
                required={true}
                error={ touched.nationalities && formData.nationalities.length === 0 }
                helperText={ touched.nationalities && formData.nationalities.length === 0  ? `${t('mandatoryField')}`
                    : ""
                }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <CustomLabeledTextField 
                    label={`${t('civilId')}`} 
                    name="civilIdNumber"
                    type="text"
                    isRTL={isRTL}
                    value={formData.civilIdNumber} 
                    onBlur={handleCivilIdBlur}
                      onChange={(e: any) => { 
                      const { name, value } = e.target;
                      if (!isNaN(Number(value))) {
                          setFormData((prevData) => ({
                          ...prevData,
                          civilIdNumber: parseFloat(value),
                      })); 
                      } else{
                      setTouched((prevData) => ({
                          ...prevData,
                          civilIdNumber: true,
                      }))
                      } 
                    }}
                    required={true} 
                    error={
                      touched.civilIdNumber && (formData.nationalities.includes(Countries.KuwaitId) && (formData.civilIdNumber === null || (formData.civilIdNumber !== null && !validateCivilId(formData.civilIdNumber))))
                    }
                    helperText={
                        touched.civilIdNumber && (
                          formData.nationalities.includes(Countries.KuwaitId) && (formData.civilIdNumber === null || (formData.civilIdNumber !== null && !validateCivilId(formData.civilIdNumber)))
                           ? `${t('civilIdValidation')}`          
                        : ""
                        ) || ""
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <CustomLabeledDatePicker
                    label={`${t('civilIdExpiryDate')}`} 
                    invalidDateMessage={`${t('invalidDateFormat')}`}  
                    value={formData.civilIdExpiryDate}  
                    isRTL={isRTL}
                    required={true} 
                    onChange={(date: string) => {
                        setFormData({ ...formData, civilIdExpiryDate: date })  
                        if (isDateEarlierThanToday(date)) { 
                            setTouched((prevData) => ({
                            ...prevData,
                            civilIdExpiryDate: true,
                            })); 
                        }else{
                            setTouched((prevData) => ({
                                ...prevData,
                                civilIdExpiryDate: false,
                                })); 
                        }
                    }}  
                    error={touched.civilIdExpiryDate}
                    helperText={touched.civilIdExpiryDate ? `${t('expiredDateValidation')}` : ""} 
                />
            </Grid>
        </Grid>  
        <Grid container item xs={12} sm={12}  mt={1} md={12} spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
                <CustomLabeledFileInput 
                    label={`${t('civilIdDocument')}`} 
                    isRTL={isRTL}
                    name="civilIdDocument"
                    type="file" 
                    value={formData.civilIdDocument?.fileName || ""}
                    onChange={handleCivilDocumentChange}
                    required={true} 
                    error={touched.civilIdDocument && formData.civilIdDocument === null}
                    helperText={
                        touched.civilIdDocument && formData.civilIdDocument === null
                        ? `${t('mandatoryField')}` 
                        : ""
                        }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <CustomLabeledTextField 
                    label={`${t('passportNumber')}`} 
                    name="passportNumber"
                    type="text"
                    isRTL={isRTL}
                    value={formData.passportNumber}  
                    onChange={(e) =>
                        setFormData((prevData) => ({ ...prevData, passportNumber: e.target.value }))
                    } 
                    required={true} 
                    error={touched.passportNumber && formData.passportNumber.trim() === ""}
                    helperText={
                        touched.passportNumber && formData.passportNumber.trim() === ""
                        ? `${t('mandatoryField')}` 
                        : ""
                        }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <CustomLabeledFileInput 
                    label={`${t('passportDocument')}`} 
                    name="passportDocument"
                    type="file"
                    isRTL={isRTL}
                    value={formData.passportDocument?.fileName || ""}
                    onChange={handlePassportDocumentChange}
                    required={true} 
                    error={(touched.passportDocument && formData.passportDocument === null) || touched.passportDocumentType || touched.passportDocumentSize}
                    helperText={(touched.passportDocument && formData.passportDocument === null) || touched.passportDocumentType ?
                        touched.passportDocumentSize ? `${t('correctFileSize')}`
                       : `${t('correctFileFormat')}` : ""}  
                    acceptedExtensions="(PDF, PNG, JPG, JPEG) - 1MB max size"
                />
            </Grid>
        </Grid>  
      </Box>
      <Grid container item xs={12} sm={12} mt={1} md={12} spacing={2} pl={5}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold'}}>
              {t('residentialAddress')}
          </Typography> 
      </Grid>
      <Box sx={RegisterStyles.boxStyle}>
        <Grid container item xs={12} sm={12} md={12} spacing={2}> 
          <Grid item xs={12} sm={6} md={4}>
              <CustomLabeledSelect 
                label={`${t('country')}`}
                isRTL={isRTL} 
                name="countryId"
                type="text"
                SelectProps={{
                    children: countries.map((item: any) => (
                    <MenuItem key={item.id} value={item.id}>
                        {isRTL ? item.nameAr : item.nameEn}
                    </MenuItem>
                    )),
                    IconComponent: () => null,
                    renderValue: (value: any) => {
                    const selected = countries.filter(
                        (item: any) => value.includes(item.id)
                    );
                    return selected.map((item) => (isRTL ? item.nameAr : item.nameEn)).join(", ");
                    },
                }}
                value={formData.countryId || ""}
                onChange={(e) =>
                    setFormData((prevData) => ({
                    ...prevData,
                    countryId: e.target.value as number,
                    }))
                }
                multiple={false}
                required={true} 
                error={touched.countryId && formData.countryId === null}
                    helperText={
                        touched.countryId && formData.countryId === null
                        ? `${t('mandatoryField')}` 
                        : ""
                        }
                />
          </Grid>   
          {formData.countryId === Countries.KuwaitId ? (
              <>
                <Grid item xs={12} sm={6} md={4}>
                    <CustomLabeledSelect 
                      label={`${t('city')}`}
                      isRTL={isRTL}
                      name="cityId"
                      type="text"
                      SelectProps={{
                          children: Array.isArray(cities.data) ? (
                            cities.data.map((item: any) => (
                              <MenuItem key={item.id} value={item.id}>
                                {isRTL ? item.nameAr : item.nameEn}
                              </MenuItem>
                            ))
                          ) : cities.data instanceof Object ? (
                            <MenuItem
                              key={(cities.data as any).id}
                              value={(cities.data as any).id}
                            > 
                              (isRTL ? (cities.data as any).nameAr : (cities.data as any).nameEn)
                            </MenuItem>
                          ) : null,

                          IconComponent: () => null,
                          renderValue: (value: any) => {
                            if (Array.isArray(cities.data)) {
                              const selected = cities.data.filter(
                                (item: any) => value.includes(item.id)
                              );
                              return selected
                                .map((item) => (isRTL ? item.nameAr : item.nameEn))
                                .join(", ");
                            } else if (cities.data instanceof Object) {
                              return (cities.data as any).nameEn || "";
                            }
                            return "";
                          },
                        }}
                      value={formData.cityId || ""}
                      onChange={(e) =>
                          setFormData((prevData) => ({
                          ...prevData,
                          cityId: e.target.value as number,
                          }))
                      }
                      multiple={false}
                      required={formData.countryId === Countries.KuwaitId ? true : false} 
                      error={touched.city && formData.countryId === Countries.KuwaitId && formData.cityId === null}
                      helperText={
                          touched.city && formData.countryId === Countries.KuwaitId && formData.cityId === null
                          ? `${t('mandatoryField')}` 
                          : ""
                          }
                  /> 
                </Grid>   
                <Grid item xs={12} sm={6} md={4}>
                    <CustomLabeledSelect 
                      label={`${t('area')}`}
                      isRTL={isRTL}
                      name="areaId"
                      type="text"
                      SelectProps={{
                          children: Array.isArray(areas.data) ? (
                            areas.data.map((item: any) => (
                              <MenuItem key={item.id} value={item.id}>
                                {isRTL ? item.nameAr : item.nameEn}
                              </MenuItem>
                            ))
                          ) : areas.data instanceof Object ? (
                            <MenuItem
                              key={(areas.data as any).id}
                              value={(areas.data as any).id}
                            > 
                              (isRTL ? (areas.data as any).nameAr : (areas.data as any).nameEn)
                            </MenuItem>
                          ) : null,

                          IconComponent: () => null,
                          renderValue: (value: any) => {
                            if (Array.isArray(areas.data)) {
                              const selected = areas.data.filter(
                                (item: any) => value.includes(item.id)
                              );
                              return selected
                                .map((item) => (isRTL ? item.nameAr : item.nameEn))
                                .join(", ");
                            } else if (areas.data instanceof Object) {
                              return (areas.data as any).nameEn || "";
                            }
                            return "";
                          },
                        }}
                      value={formData.areaId || ""}
                      onChange={(e) =>
                          setFormData((prevData) => ({
                          ...prevData,
                          areaId: e.target.value as number,
                          }))
                      }
                      multiple={false}
                      required={formData.countryId === Countries.KuwaitId ? true : false} 
                      error={touched.area && formData.countryId === Countries.KuwaitId && formData.areaId === null}
                      helperText={
                          touched.area && formData.countryId === Countries.KuwaitId && formData.areaId === null
                          ? `${t('mandatoryField')}` 
                          : ""
                          }
                  /> 
                </Grid>  
              </>
          ):(
            <>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomLabeledTextField 
                  label={`${t('city')}`} 
                  name="city"
                  type="text"
                  isRTL={isRTL}
                  value={formData.city} 
                  onChange={(e) =>
                    setFormData((prevData) => ({ ...prevData, city: e.target.value }))
                  }
                  required={formData.countryId === Countries.KuwaitId ? false : true} 
                  error={touched.city && formData.countryId !== Countries.KuwaitId && formData.city.trim() === ""}
                  helperText={
                      touched.city && formData.countryId !== Countries.KuwaitId && formData.city.trim() === ""
                      ? `${t('mandatoryField')}` 
                      : ""
                      }
                />
                </Grid>   
                <Grid item xs={12} sm={6} md={4}>
                  <CustomLabeledTextField 
                  label={`${t('area')}`} 
                  name="area"
                  type="text"
                  isRTL={isRTL}
                  value={formData.area} 
                  onChange={(e) =>
                    setFormData((prevData) => ({ ...prevData, area: e.target.value }))
                  }
                  required={formData.countryId === Countries.KuwaitId ? false : true} 
                  error={touched.area && formData.countryId !== Countries.KuwaitId && formData.area.trim() === ""}
                  helperText={
                      touched.area && formData.countryId !== Countries.KuwaitId && formData.area.trim() === ""
                      ? `${t('mandatoryField')}` 
                      : ""
                      }
                />
                </Grid>   
              </>
          )}
        </Grid>
        <Grid container item xs={12} sm={12} md={12} spacing={2}> 
        {formData.countryId === Countries.KuwaitId ? (
              <Grid item xs={12} sm={6} md={4}>
              <CustomLabeledSelect 
                label={`${t('suburb')}`}
                isRTL={isRTL}
                name="suburbId"
                type="text"
                SelectProps={{
                    children: Array.isArray(suburbs.data) ? (
                      suburbs.data.map((item: any) => (
                        <MenuItem key={item.id} value={item.id}>
                          {isRTL ? item.nameAr : item.nameEn}
                        </MenuItem>
                      ))
                    ) : suburbs.data instanceof Object ? (
                      <MenuItem
                        key={(suburbs.data as any).id}
                        value={(suburbs.data as any).id}
                      > 
                        (isRTL ? (suburbs.data as any).nameAr : (suburbs.data as any).nameEn)
                      </MenuItem>
                    ) : null,

                    IconComponent: () => null,
                    renderValue: (value: any) => {
                      if (Array.isArray(suburbs.data)) {
                        const selected = suburbs.data.filter(
                          (item: any) => value.includes(item.id)
                        );
                        return selected
                          .map((item) => (isRTL ? item.nameAr : item.nameEn))
                          .join(", ");
                      } else if (suburbs.data instanceof Object) {
                        return (suburbs.data as any).nameEn || "";
                      }
                      return "";
                    },
                  }}
                value={formData.suburbId || ""}
                onChange={(e) =>
                    setFormData((prevData) => ({
                    ...prevData,
                    suburbId: e.target.value as number,
                    }))
                }
                multiple={false}
                required={formData.countryId === Countries.KuwaitId ? true : false} 
                error={touched.suburb && formData.countryId === Countries.KuwaitId && formData.suburbId === null}
                helperText={
                    touched.suburb && formData.countryId === Countries.KuwaitId && formData.suburbId === null
                    ? `${t('mandatoryField')}` 
                    : ""
                    }
            /> 
          </Grid> 
        ):
            (
              <Grid item xs={12} sm={6} md={4}>
                  <CustomLabeledTextField 
                  label={`${t('suburb')}`} 
                  name="suburb"
                  type="text"
                  isRTL={isRTL}
                  value={formData.suburb} 
                  onChange={(e) =>
                    setFormData((prevData) => ({ ...prevData, suburb: e.target.value }))
                  }
                  required={formData.countryId === Countries.KuwaitId ? false : true} 
                  error={touched.suburb && formData.countryId !== Countries.KuwaitId && formData.suburb.trim() === ""}
                  helperText={
                      touched.suburb && formData.countryId !== Countries.KuwaitId && formData.suburb.trim() === ""
                      ? `${t('mandatoryField')}` 
                      : ""
                      }
                />
                </Grid> 
            )}   
          <Grid item xs={12} sm={6} md={4}>
              <CustomLabeledTextField 
                label={`${t('block')}`} 
                name="block"
                type="text"
                isRTL={isRTL}
                value={formData.block} 
                onChange={(e) =>
                  setFormData((prevData) => ({ ...prevData, block: e.target.value }))
                }
                required={true} 
                error={touched.block && formData.block.trim() === ""}
                  helperText={
                      touched.block && formData.block.trim() === ""
                      ? `${t('mandatoryField')}` 
                      : ""
                      }
                /> 
          </Grid>   
          <Grid item xs={12} sm={6} md={4}>
              <CustomLabeledTextField 
                label={`${t('street')}`} 
                name="street"
                type="text"
                isRTL={isRTL}
                value={formData.street} 
                onChange={(e) =>
                  setFormData((prevData) => ({ ...prevData, street: e.target.value }))
                }
                required={true} 
                error={touched.street && formData.street.trim() === ""}
                  helperText={
                      touched.street && formData.street.trim() === ""
                      ? `${t('mandatoryField')}` 
                      : ""
                      }
                /> 
          </Grid>  
        </Grid>
        <Grid container item xs={12} sm={12} md={12} spacing={2}> 
          <Grid item xs={12} sm={6} md={4}>
            <CustomLabeledTextField
                label={`${t('buildingName')}`}  
                name="buildingName"
                type="text"
                isRTL={isRTL}
                value={formData.buildingName} 
                onChange={(e) =>
                  setFormData((prevData) => ({ ...prevData, buildingName: e.target.value }))
                }
                required={true} 
                error={touched.buildingName && formData.buildingName.trim() === ""}
                  helperText={
                      touched.buildingName && formData.buildingName.trim() === ""
                      ? `${t('mandatoryField')}` 
                      : ""
                      }
                /> 
          </Grid>   
          <Grid item xs={12} sm={6} md={4}>
              <CustomLabeledTextField 
                label={`${t('buildingNumber')}`}  
                name="buildingNumber"
                type="text"
                isRTL={isRTL}
                value={formData.buildingNumber} 
                onChange={(e) =>
                  setFormData((prevData) => ({ ...prevData, buildingNumber: e.target.value }))
                }
                required={true} 
                error={touched.buildingNumber && formData.buildingNumber.trim() === ""}
                  helperText={
                      touched.buildingNumber && formData.buildingNumber.trim() === ""
                      ? `${t('mandatoryField')}` 
                      : ""
                      }
                /> 
          </Grid>   
          <Grid item xs={12} sm={6} md={4}>
              <CustomLabeledTextField 
                label={`${t('postalCode')}`} 
                name="postalCode"
                type="text"
                isRTL={isRTL}
                value={formData.postalCode} 
                onChange={(e) =>
                  setFormData((prevData) => ({ ...prevData, postalCode: e.target.value }))
                }
                required={true} 
                error={touched.postalCode && formData.postalCode.trim() === ""}
                  helperText={
                      touched.postalCode && formData.postalCode.trim() === ""
                      ? `${t('mandatoryField')}` 
                      : ""
                      }
                /> 
          </Grid>  
        </Grid> 
      </Box>
      <Box sx={RegisterStyles.boxStyle}>
        {formData.employers.map((employer, index) => ( 
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <CustomLabeledTextField 
                  label={`${t('employerName')}`} 
                  name="name"
                  type="text"
                  isRTL={isRTL}
                  required={true}
                  value={employer.name}
                  onChange={(e) =>
                    handleInputChange(index, "name", e.target.value)
                  }
                  error={touched.employers?.[index]?.name || false}
                  helperText={
                    touched.employers?.[index]?.name
                      ? `${t('mandatoryField')}`
                      : ""
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <CustomLabeledTextField 
                  label={`${t('employerAddress')}`} 
                  name="address"
                  type="text"
                  isRTL={isRTL}
                  required={true}
                  value={employer.address}
                  onChange={(e) =>
                    handleInputChange(index, "address", e.target.value)
                  }
                  error={touched.employers?.[index]?.address || false}
                  helperText={
                    touched.employers?.[index]?.address
                      ? `${t('mandatoryField')}`
                      : ""
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}> 
                <CustomLabeledTextField 
                  label={`${t('employerPhone')}`} 
                  name="phoneNumber"
                  type="text"
                  isRTL={isRTL}
                  required={true}
                  value={employer.phoneNumber}
                    onChange={(e: any) => { 
                    const { value } = e.target;
                    if (!isNaN(Number(value)) || value === "") {
                      handleInputChange(index, "phoneNumber", value);
                    }
                  }}
                  isPhoneNumber={true}
                  countryCode={employer.phoneCountryId || 0}
                  countryCodes={countries || []} 
                  onCountryCodeChange={(countryId) => {
                    handleCountryCodeChange(index, countryId);
                    if(employer.phoneNumber === null || (countryId == Countries.KuwaitId && employer.phoneNumber !== null && !kuwaitPhoneNumberRegex.test(employer.phoneNumber.toString()) || employer.phoneNumber?.toString().length != kuwaitPhoneNumberDigits)){
                      setTouched((prevData) => ({
                          ...prevData,
                          phoneNumber: true,
                      }))
                  };
                  }}
                  onBlur={() => {  
                    if(employer.phoneNumber === null || (employer.phoneCountryId == Countries.KuwaitId && employer.phoneNumber !== null && !kuwaitPhoneNumberRegex.test(employer.phoneNumber.toString()) || employer.phoneNumber?.toString().length != kuwaitPhoneNumberDigits)){
                      setTouched((prevData) => ({
                          ...prevData,
                          phoneNumber: true,
                      }))
                  };
                  }} 
                  error={touched.employers?.[index]?.phoneNumber || false}
                  helperText={
                    touched.employers?.[index]?.phoneNumber && employer.phoneCountryId === Countries.KuwaitId
                      ? `${t('phoneNumberValidation')}`
                      : touched.employers?.[index]?.phoneNumber && employer.phoneCountryId !== Countries.KuwaitId
                      ? `${t('mandatoryField')}`
                      : ""
                  } 
                />

              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <CustomLabeledTextField 
                  label={`${t('employerEmail')}`} 
                  name="email"
                  type="text"
                  isRTL={isRTL}
                  required={true}
                  value={employer.email}
                  onChange={(e) =>
                    handleInputChange(index, "email", e.target.value)
                  }
                  error={touched.employers?.[index]?.email || false}
                  helperText={
                    touched.employers?.[index]?.email
                      ? `${t('mandatoryField')}`
                      : ""
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}> 
                <CustomLabeledSelect 
                  label={`${t('designation')}`} 
                  name="designationId"
                  isRTL={isRTL}
                  type="text"
                  SelectProps={{
                      children: Array.isArray(designations.data) ? (
                        designations.data.map((item: any) => (
                          <MenuItem key={item.id} value={item.id}>
                            {isRTL ? item.valueAr : item.valueEn}
                          </MenuItem>
                        ))
                      ) : designations.data instanceof Object ? (
                        <MenuItem
                          key={(designations.data as any).id}
                          value={(designations.data as any).id}
                        >
                          {(designations.data as any).valueEn}
                        </MenuItem>
                      ) : null,

                      IconComponent: () => null,
                      renderValue: (value: any) => {
                        if (Array.isArray(designations.data)) {
                          const selected = designations.data.filter(
                            (item: any) => value.includes(item.id)
                          );
                          return selected
                            .map((item) => item.valueEn)
                            .join(", ");
                        } else if (designations.data instanceof Object) {
                          return (designations.data as any).valueEn || "";
                        }
                        return "";
                      },
                    }}
                  value={employer.designationId || ""}
                  onChange={(e) =>
                    handleDesignationChange(index, Number(e.target.value) || 0)
                  } 
                  multiple={false}
                  required={true} 
                  error={touched.employers?.[index]?.designationId || false}
                  helperText={
                    touched.employers?.[index]?.designationId
                      ? `${t('mandatoryField')}`
                      : ""
                  }  
                /> 
              </Grid>
              {formData.employers.length > 1 && (
                <Grid item xs={12} sm={6} md={4} alignSelf="center"> 
                  <CustomIcon
                    tooltipText="remove"
                    onClick={() => removeEmployer(index)}
                    style={GridStyles.deleteIcon} 
                  >
                    <Cancel  />
                  </CustomIcon>
                </Grid>
              )} 
            </Grid> 
        ))} 
        <CustomIcon
            tooltipText="add"
            onClick={addEmployer} 
            style={GridStyles.editIcon} 
          >
          <AddCircle style={{marginLeft:'5px'}} />  {t('addAnother')}
        </CustomIcon> 
      </Box>
    </Box>
  );
};
 
PersonalInformation.validate = (formData: InvestorModel, confirmPassword? : string): RegisterTouched => { 
  const hasErrors = formData.employers.every((employer) => {
    return (
      employer.name.trim() === "" ||
      employer.address.trim() === "" ||
      employer.phoneNumber === null ||
      !kuwaitPhoneNumberRegex.test(employer.phoneNumber.toString()) ||
      employer.phoneNumber.toString().length !== kuwaitPhoneNumberDigits ||
      !emailRegex.test(employer.email) ||
      employer.phoneCountryId === null ||
      employer.designationId === null
    );
  }); 
  const newTouched = {
    email: formData.email.trim() === "" || !emailRegex.test(formData.email),
    mobileNumber: (formData.mobileNumber === null || (formData.mobileCountryId === Countries.KuwaitId && formData.mobileNumber !== null && (!kuwaitPhoneNumberRegex.test(formData.mobileNumber.toString()) || formData.mobileNumber.toString().length != kuwaitPhoneNumberDigits) || formData.mobileNumber === null)),
    receiveCommunicationId: !formData.receiveCommunicationId,
    firstName: formData.firstName.trim() === "",
    middleName: formData.middleName.trim() === "",
    lastName: formData.lastName.trim() === "",
    birthDate: formData.birthDate.trim() === "",
    birthPlace: formData.birthPlace.trim() === "",
    genderId: formData.genderId === null,
    countryId: formData.countryId === null,
    nationalities: formData.nationalities.length === 0, 
    city:(formData.countryId === Countries.KuwaitId && formData.cityId === null) || (formData.countryId !== Countries.KuwaitId && formData.city.trim() === ""),
    area:(formData.countryId === Countries.KuwaitId && formData.areaId === null) || (formData.countryId !== Countries.KuwaitId && formData.area.trim() === ""),
    suburb:(formData.countryId === Countries.KuwaitId && formData.suburbId === null) || (formData.countryId !== Countries.KuwaitId && formData.suburb.trim() === ""),
    block:formData.block.trim() === "",
    street:formData.street.trim() === "",
    buildingName:formData.buildingName.trim() === "",
    buildingNumber:formData.buildingNumber.trim() === "",
    postalCode:formData.postalCode.trim() === "", 
    password:formData.id === 0 &&
     ( formData.password.trim() === "" ||
     formData.password.length < passwordCharactersMinimum ||
     !Uppercase.test(formData.password) ||
     !Lowercase.test(formData.password) ||
     !Numbercase.test(formData.password) ||
     !SpecialChar.test(formData.password) ||
     formData.firstName.toLowerCase().trim() !== "" && formData.password.toLowerCase().includes(formData.firstName?.toLowerCase()) ||
     formData.lastName.toLowerCase().trim() !== "" && formData.password.toLowerCase().includes(formData.lastName?.toLowerCase())),
    confirmPassword: formData.id === 0 &&
    ( confirmPassword && (confirmPassword.trim() === "" || confirmPassword !== formData.password) || false),
    civilIdDocument:formData.civilIdDocument === null,
    passportDocument:formData.passportDocument === null,
    aicClient:formData.aicClientId === null,
    passportNumber:formData.passportNumber.trim() === "",
    aicPortfolioNumber: formData.aicPortfolioNumber.trim() === "" && formData.aicClientId === AICClient.Yes,  
    civilIdNumber:formData.nationalities.includes(Countries.KuwaitId) && (formData.civilIdNumber === null || (formData.civilIdNumber !== null && !validateCivilId(formData.civilIdNumber))),
    civilIdExpiryDate: false, 
    employersFlag: hasErrors ? true : false,
  }; 
  if (formData.civilIdExpiryDate.trim() === "" || (formData.civilIdExpiryDate.trim() !== "" && isDateEarlierThanToday(formData.civilIdExpiryDate))) {
      newTouched.civilIdExpiryDate = true;
  } 
  return newTouched;
}; 

export default PersonalInformation;
